<template>
  <button
    :title="$t('sharing.clipboard')"
    type="button"
    class="clipboard relative focus:outline-none"
    @click="share"
  >
    <span :class="{ show: clicked }" class="success">{{
      $t('sharing.copied')
    }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-full w-full"
      fill="none"
      viewBox="0 0 30 30"
    >
      <rect
        width="29.5"
        height="29.5"
        x=".3"
        y=".3"
        stroke="#fff"
        stroke-width=".5"
        rx="14.8"
      />
      <path
        fill="#fff"
        d="M18.2 7.2a4 4 0 0 0-1.7.8c-.4.2-3.4 3.3-3.5 3.5v.1c.6-.1 1.3 0 1.9.1h.3l1.3-1.1c1-1.1 1.2-1.3 1.5-1.4a2 2 0 0 1 2.3.4c.5.5.7.9.7 1.6 0 .4 0 .7-.3 1a35.7 35.7 0 0 1-3.5 3.5 2 2 0 0 1-1.5 0c-.3 0-.5 0-.8-.3-.4-.4-.6-.4-1-.3a1 1 0 0 0-.6.6c0 .4 0 .7.4 1a3.9 3.9 0 0 0 5 .2l3.5-3.5.5-1.3c.2-.5.2-1.4 0-1.9a4.2 4.2 0 0 0-2.6-2.8c-.6-.2-1.3-.3-2-.2z"
      />
      <path
        fill="#fff"
        d="M13.2 12.3c-.6 0-1.2.3-1.7.7L8 16.5c-1 1.2-1.1 2.8-.4 4.1.5 1 1.5 1.8 2.6 2.1.5.2 1.3.2 1.9 0 .4 0 1-.3 1.3-.5.5-.4 3.8-3.7 3.7-3.8h-.4c-.5.1-1 0-1.6 0l-.3-.2-1.2 1.2-1.4 1.3c-.4.2-.6.3-1 .3a2 2 0 0 1-1.6-.7 2 2 0 0 1-.4-2.4l1.7-1.8c1.4-1.4 1.6-1.6 1.9-1.7a2 2 0 0 1 1.6-.2l.7.4c.4.4.6.4 1 .4.2-.1.6-.4.6-.7.1-.4 0-.7-.4-1l-1-.7c-.6-.2-1.5-.4-2-.3z"
      />
    </svg>
  </button>
</template>

<script>
import * as clipboard from 'clipboard-polyfill'

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      clicked: false,
    }
  },
  methods: {
    share() {
      this.$store.dispatch('tracking/trackGeneric', {
        category: 'sharing',
        action: 'clipboard',
        label: this.text,
      })
      this.clicked = true
      clipboard.writeText(this.url)
      window.setTimeout(() => (this.clicked = false), 1000)
    },
  },
}
</script>

<style scoped>
@import '~components/social/ShareToClipboard.css';
</style>
